import React, { useState } from "react";
import { Box, TextField, MenuItem, Typography, Button, useMediaQuery } from "@mui/material";

export default function ProdutosHeader({ isMobile, openDrawer, onSortChange }) {
    const [ordenacao, setOrdenacao] = useState("relevancia");

    const handleOrdenacaoChange = (event) => {
        const valor = event.target.value;
        setOrdenacao(valor);
        if (onSortChange) {
            onSortChange(valor);
        }
    };

    return (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                Produtos
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 2,
                    alignItems: isMobile ? "stretch" : "center",
                }}
            >
                {/* BUSCA */}
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Buscar produto..."
                    sx={{
                        background: "#fff",
                    }}
                />

                {/* SELECT */}
                <TextField
                    select
                    variant="outlined"
                    label="Ordenar por"
                    value={ordenacao}
                    onChange={handleOrdenacaoChange}
                    sx={{
                        width: isMobile ? "100%" : 220,
                        background: "#fff",
                        "& .MuiInputLabel-root": {
                            color: "var(--azul)",
                            fontWeight: 600,
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                            color: "var(--azul) !important",
                        },
                    }}
                >
                    <MenuItem value="relevancia">Mais relevantes</MenuItem>
                    <MenuItem value="preco_menor">Menor preço</MenuItem>
                    <MenuItem value="preco_maior">Maior preço</MenuItem>
                    <MenuItem value="novidades">Novidades</MenuItem>
                </TextField>

                {/* BOTÃO FILTROS - MOBILE APENAS */}
                {isMobile && (
                    <Button
                        variant="contained"
                        onClick={openDrawer}
                        sx={{
                            background: "var(--azul)",
                            fontWeight: 700,
                            height: "56px",
                        }}
                    >
                        Filtros
                    </Button>
                )}
            </Box>
        </Box>
    );
}
